import { tv, type VariantProps } from "tailwind-variants"
import { classNames } from "../../utils"
import { borderVariants } from "./border"

export type TooltipVariantProps = VariantProps<typeof tooltipVariants>

const fadeInClassNames = classNames(
  "animate-in fade-in",
  // Handling both Tooltip and Popover states for convenience
  "data-[state=closed]:animate-out data-[state=closed]:fade-out",
  // For base-ui components
  "data-[closed]:animate-out data-[closed]:fade-out",
)

export const tooltipVariants = tv({
  base: classNames(
    "z-tooltip rounded-md bg-bg-primary font-sans text-sm outline-hidden",
    borderVariants({ border: "border-1" }),
  ),
  variants: {
    animation: {
      "fade-in": fadeInClassNames,
      "slide-out": classNames(
        fadeInClassNames,
        "data-[side=top]:slide-in-from-bottom-2",
        "data-[side=right]:slide-in-from-left-2",
        "data-[side=bottom]:slide-in-from-top-2",
        "data-[side=left]:slide-in-from-right-2",
      ),
      none: "",
    },
  },
})
